import { useMemo } from "react";
import Anser from "anser";

type AnsiTextProps = {
  /** Raw text, which may contain ANSI escape sequences. */
  children: string;
  className?: string;
};

const spanStyle = (entry: Anser.AnserJsonEntry) => {
  const style: Record<string, string> = {};
  if (entry.fg) style.color = `rgb(${entry.fg})`;
  if (entry.bg) style.backgroundColor = `rgb(${entry.bg})`;
  if (entry.decorations.includes("bold")) style.fontWeight = "600";
  if (entry.decorations.includes("italic")) style.fontStyle = "italic";
  if (entry.decorations.includes("underline")) style.textDecoration = "underline";
  if (entry.decorations.includes("dim")) style.opacity = "0.7";
  return style;
};

/**
 * AnsiText renders text containing ANSI escape sequences as styled spans. Text without any escape
 * sequences renders as a single plain span, inheriting the surrounding colour.
 */
export const AnsiText = ({ children, className }: AnsiTextProps) => {
  const entries = useMemo(
    () => Anser.ansiToJson(children, { json: true, remove_empty: true, use_classes: false }),
    [children],
  );

  return (
    <span className={className}>
      {entries.map((entry, index) => (
        <span key={index} style={spanStyle(entry)}>
          {entry.content}
        </span>
      ))}
    </span>
  );
};
